module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTStd-Bd.ec906852.woff";